import AuthModal from '../components/auth-modal/auth-modal';
import { REG_DRIVER_LOCATION } from './analytics-constants';

import internalLink from './internal-link';

const registerLink = (calc, { element, location }, text) => {
  const trkParams = {
    element,
    location,
    copy: 'get_your_free_credit_score',
  };
  const link = internalLink(
    calc,
    '/home/register?flow=credit-score',
    trkParams
  );
  return {
    linkComponent: (props) => (
      <AuthModal driverLocation={REG_DRIVER_LOCATION.TOOL_CARD} {...props} />
    ),
    url: link,
    text,
    href: link,
  };
};
export default registerLink;
